/**************************************************
 * Nombre:       Tarjeta_Perfil_Ocupacional
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../Constantes";
import {theme} from "../../Tema";


const Tarjeta_Perfil_Ocupacional = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: 'white',
                p: 3,
                color: '#000',
                boxShadow: 4
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography
                    sx={{
                        fontFamily: NEGRITA,
                        fontSize: 28,
                        fontWeight: 600,
                        color: theme.palette.primary.main,
                        lineHeight: 1.1
                    }}>Por que
                    Estudiar TECNICO LABORAL
                    POR COMPETENCIAS ASISTENTE ADMINISTRATIVO</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography
                    sx={{fontSize: 16, fontWeight: 400}}>
                    El egresado del programa Técnico Laboral en Asistente Administrativo está preparado para apoyar de
                    manera eficiente las áreas
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography
                    sx={{fontSize: 16, fontWeight: 400}}>
                    El egresado del programa Técnico Laboral en Asistente Administrativo está preparado para apoyar de
                    manera eficiente las áreas
                </Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Perfil_Ocupacional    